.Spinner {
}
